import { FIELD_TYPES } from 'utility/constants';
import SimpleOptions from './options/Simple';
import StatusOptions from './options/Status';
import PhoneNumberOptions from './options/PhoneNumber';
import TextOptions from './options/Text';
import PriceOptions from './options/Price';
import RatingOptions from './options/Rating';
import YesNoOptions from './options/YesNo';
import RelationshipOptions from './options/Relationship';
import ActivityRelationshipOptions from './options/ActivityRelationship';
import DynamicTagOptions from './options/DynamicTag';
import { FilesOptions } from './options/Files';

export const STEPS = {
  FIELD_SETTINGS: 'settings',
  FIELD_TYPE: 'type',
  FIELD_OPTIONS: 'options',
};

export const LIST_OF_FIELDS = [
  FIELD_TYPES.Checkbox,
  {
    ...FIELD_TYPES.Checkboxes,
    options: SimpleOptions,
    optionsValidation: true,
    optionsLimit: 250,
  },
  FIELD_TYPES.Date,
  FIELD_TYPES.DateTime,
  {
    ...FIELD_TYPES.Dropdown,
    options: SimpleOptions,
    optionsValidation: true,
    optionsLimit: 250,
  },
  {
    ...FIELD_TYPES.DynamicTags,
    options: DynamicTagOptions,
    optionsValidation: false,
  },
  FIELD_TYPES.Email,
  {
    ...FIELD_TYPES.Files,
    options: FilesOptions,
    optionsValidation: false,
  },
  {
    ...FIELD_TYPES.LongText,
    options: TextOptions,
    optionsValidation: false,
  },
  FIELD_TYPES.Decimal,
  FIELD_TYPES.Integer,
  {
    ...FIELD_TYPES.PhoneNumber,
    options: PhoneNumberOptions,
    optionsValidation: false,
  },
  {
    ...FIELD_TYPES.Money,
    options: PriceOptions,
    optionsValidation: false,
  },
  {
    ...FIELD_TYPES.Radio,
    options: SimpleOptions,
    optionsValidation: true,
    optionsLimit: 250,
  },
  {
    ...FIELD_TYPES.Rating,
    options: RatingOptions,
    optionsValidation: true,
  },
  {
    ...FIELD_TYPES.Relationship,
    options: RelationshipOptions,
    optionsValidation: true,
  },
  {
    ...FIELD_TYPES.Status,
    options: StatusOptions,
    optionsValidation: true,
    optionsLimit: 250,
  },
  FIELD_TYPES.TeamSelector,
  {
    ...FIELD_TYPES.Text,
    options: TextOptions,
    optionsValidation: false,
  },
  {
    ...FIELD_TYPES.YesNoMaybe,
    options: YesNoOptions,
    optionsValidation: false,
  },
];

export const LIST_OF_ACTIVITY_FIELDS = [
  FIELD_TYPES.Checkbox,
  {
    ...FIELD_TYPES.Checkboxes,
    options: SimpleOptions,
    optionsValidation: true,
    optionsLimit: 250,
  },
  FIELD_TYPES.Date,
  FIELD_TYPES.DateTime,
  {
    ...FIELD_TYPES.Dropdown,
    options: SimpleOptions,
    optionsValidation: true,
    optionsLimit: 250,
  },
  {
    ...FIELD_TYPES.DynamicTags,
    options: DynamicTagOptions,
    optionsValidation: false,
  },
  FIELD_TYPES.Email,
  {
    ...FIELD_TYPES.Files,
    options: FilesOptions,
    optionsValidation: false,
  },
  {
    ...FIELD_TYPES.LongText,
    options: TextOptions,
    optionsValidation: false,
  },
  FIELD_TYPES.Decimal,
  FIELD_TYPES.Integer,
  {
    ...FIELD_TYPES.PhoneNumber,
    options: PhoneNumberOptions,
    optionsValidation: false,
  },
  {
    ...FIELD_TYPES.Money,
    options: PriceOptions,
    optionsValidation: false,
  },
  {
    ...FIELD_TYPES.Radio,
    options: SimpleOptions,
    optionsValidation: true,
    optionsLimit: 250,
  },
  {
    ...FIELD_TYPES.Rating,
    options: RatingOptions,
    optionsValidation: true,
  },
  {
    ...FIELD_TYPES.Relationship,
    options: ActivityRelationshipOptions,
    optionsValidation: true,
  },
  {
    ...FIELD_TYPES.Status,
    options: StatusOptions,
    optionsValidation: true,
    optionsLimit: 250,
  },
  FIELD_TYPES.TeamSelector,
  {
    ...FIELD_TYPES.Text,
    options: TextOptions,
    optionsValidation: false,
  },
  {
    ...FIELD_TYPES.YesNoMaybe,
    options: YesNoOptions,
    optionsValidation: false,
  },
];

export const LIST_OF_FORM_FIELDS = [
  FIELD_TYPES.Checkbox,
  {
    ...FIELD_TYPES.Checkboxes,
    options: SimpleOptions,
    optionsValidation: true,
    optionsLimit: 250,
  },
  FIELD_TYPES.Date,
  FIELD_TYPES.DateTime,
  {
    ...FIELD_TYPES.Dropdown,
    options: SimpleOptions,
    optionsValidation: true,
    optionsLimit: 250,
  },
  FIELD_TYPES.Email,
  {
    ...FIELD_TYPES.Files,
    options: FilesOptions,
    optionsValidation: false,
  },
  FIELD_TYPES.LongText,
  FIELD_TYPES.Decimal,
  FIELD_TYPES.Integer,
  {
    ...FIELD_TYPES.PhoneNumber,
    options: PhoneNumberOptions,
    optionsValidation: false,
  },
  {
    ...FIELD_TYPES.Money,
    options: PriceOptions,
    optionsValidation: false,
  },
  {
    ...FIELD_TYPES.Radio,
    options: SimpleOptions,
    optionsValidation: true,
    optionsLimit: 250,
  },
  {
    ...FIELD_TYPES.Rating,
    options: RatingOptions,
    optionsValidation: true,
  },
  {
    ...FIELD_TYPES.Status,
    options: StatusOptions,
    optionsValidation: true,
    optionsLimit: 250,
  },
  FIELD_TYPES.TeamSelector,
  FIELD_TYPES.Text,
  {
    ...FIELD_TYPES.YesNoMaybe,
    options: YesNoOptions,
    optionsValidation: false,
  },
];
